/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartPieA2Icon32Regular = forwardRef('DataChartPieA2Icon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.541 3.011A1.484 1.484 0 0 0 15 4.5v11a1.5 1.5 0 0 0 1.5 1.5h11c.817 0 1.525-.67 1.489-1.541A12.998 12.998 0 0 0 16.54 3.01ZM17 15V5.046A11 11 0 0 1 26.954 15H17Z" }),
        React.createElement("path", { d: "M11.416 6a1 1 0 0 0-.834-1.817 13 13 0 1 0 17.671 16.16 1 1 0 0 0-1.885-.669A11 11 0 1 1 11.416 6.001Z" })));
});
